import { render, staticRenderFns } from "./flagged-costs-no-rows-overlay.vue?vue&type=template&id=2c837222&scoped=true"
import script from "./flagged-costs-no-rows-overlay.vue?vue&type=script&lang=ts"
export * from "./flagged-costs-no-rows-overlay.vue?vue&type=script&lang=ts"
import style0 from "./flagged-costs-no-rows-overlay.vue?vue&type=style&index=0&id=2c837222&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c837222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c837222')) {
      api.createRecord('2c837222', component.options)
    } else {
      api.reload('2c837222', component.options)
    }
    module.hot.accept("./flagged-costs-no-rows-overlay.vue?vue&type=template&id=2c837222&scoped=true", function () {
      api.rerender('2c837222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/flagged-costs-table/flagged-costs-no-rows-overlay.vue"
export default component.exports